import * as React from "react";
const SvgArrowUp24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 12,
        fill: "black",
        viewBox: "0 0 20 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m.293 10.293 1.414 1.414L10 3.414l8.293 8.293 1.414-1.414L10 .586.293 10.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowUp24Px;
